var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutCircleRLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24991 26.5832C7.24991 13.2359 18.0693 2.4165 31.4166 2.4165C44.7638 2.4165 55.5832 13.2359 55.5832 26.5832C55.5861 30.3354 54.7138 34.0366 53.0357 37.3927C51.3577 40.7489 48.9201 43.6674 45.9166 45.9165L45.9166 39.3673C48.3773 36.5766 49.9805 33.1352 50.5339 29.4559C51.0872 25.7766 50.5671 22.0158 49.036 18.6248C47.5049 15.2338 45.0278 12.3566 41.902 10.3385C38.7763 8.3204 35.1346 7.2471 31.4139 7.24741C27.6933 7.24772 24.0517 8.32162 20.9263 10.3403C17.8008 12.3589 15.3243 15.2365 13.7937 18.6277C12.2632 22.019 11.7437 25.7799 12.2976 29.4591C12.8516 33.1383 14.4554 36.5795 16.9166 39.3697L16.9166 45.9189C13.9128 43.6696 11.475 40.7506 9.79688 37.3941C8.1188 34.0375 7.24672 30.3358 7.24991 26.5832ZM21.7499 43.4998L28.9999 43.4998L28.9999 24.1665L33.8332 24.1665L33.8332 43.4998L41.0832 43.4998L31.4166 55.5832L21.7499 43.4998Z",
    fill: "#61D64A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutCircleRLine);
export default __webpack_public_path__ + "static/media/logout-circle-r-line.024db3dba6ce8043191c2669ee39dcd8.svg";
export { ForwardRef as ReactComponent };